import { Injectable, Output, EventEmitter, OnInit } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError, map } from "rxjs/operators";
//import { AuthenticationService } from "../../app.service";

@Injectable()
export class homeServices {
  
  private headerComponent!: () => void;

  constructor(
  ) { }
  
}
